/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Namespace contains common and page-specific functions.
    var RiseBase = {

        // All pages
        'common': {
            init: function () {

                // Remove html.no-js
                $('html').removeClass('no-js');

                /**
                 * Open all external links in a new tab.
                 *
                 * This adds the ":external" selector to jQuery.
                 * Then queries all external links, tests them, and adds external attributes.
                 */
                $.expr[':'].external = function (obj) {
                    return !obj.href.match(/^mailto:/) &&
                        !obj.href.match(/^tel:/) &&
                        (obj.hostname !== location.hostname) &&
                        !obj.href.match(/^javascript:/) &&
                        !obj.href.match(/^$/);
                };
                $('a:external').attr('target', '_blank').attr('rel', 'external');

                /**
                 * Test the User Agent for Internet Explorer.
                 *
                 * If using Internet Explorer, add ie & ie-{version} classes
                 * to the root html element.
                 */
                (function internetExplorer() {
                    function detectIE() {
                        var ua = window.navigator.userAgent;

                        var msie = ua.indexOf('MSIE ');
                        if (msie > 0) {
                            // IE 10 or older => return version number
                            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                        }

                        var trident = ua.indexOf('Trident/');
                        if (trident > 0) {
                            // IE 11 => return version number
                            var rv = ua.indexOf('rv:');
                            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                        }

                        var edge = ua.indexOf('Edge/');
                        if (edge > 0) {
                            // Edge (IE 12+) => return version number
                            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                        }

                        // other browser
                        return false;
                    }

                    var IEVersion = detectIE();
                    if (IEVersion) {
                        $('html').addClass('ie').addClass('ie-' + IEVersion);
                    }
                })();

                /**
                 * Primary navigation menu.
                 */
                (function primaryNavigation() {
                    var primaryNavigation = $('#js-primary-nav'),
                        menuToggle = $('#js-toggle-nav-main').unbind();

                    menuToggle.on('click', function (e) {
                        e.preventDefault();
                        $('body').toggleClass('menu-open');
                        primaryNavigation.slideToggle(function () {
                            if (primaryNavigation.is(':hidden')) {
                                primaryNavigation.removeAttr('style');
                            }
                        });
                    });
                })();
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },

        'has_map': {
            init: function () {
                var bittersMap = (function () {
                    var address = businessData.address,
                        businessName = businessData.businessName,
                        phoneNumber = businessData.phoneNumber;

                    var contentString =
                        '<div id="map-content">' +
                        '<h2 class="map-content-heading">' + businessName + '</h2>' +
                        '<div class="map-content-body">' +
                        '<a href="http://maps.google.com/?q=' + encodeURI(address) + '" target="_blank">' + address + '</a>' +
                        '<a href="tel:' + phoneNumber + '">' + phoneNumber + '</a>' +
                        '</div>' +
                        '</div>';

                    var myLatlng = new google.maps.LatLng(59.342457, 18.057340),
                        mapCenter = new google.maps.LatLng(59.340458, 18.057340),
                        mapCanvas = document.getElementById('map_canvas'),
                        mapOptions = {
                            center: mapCenter,
                            zoom: 13,
                            scrollwheel: false,
                            draggable: true,
                            disableDefaultUI: true,
                            mapTypeId: google.maps.MapTypeId.ROADMAP
                        },
                        geocoder = new google.maps.Geocoder(),
                        map = new google.maps.Map(mapCanvas, mapOptions);

                    var infowindow = new google.maps.InfoWindow({
                            content: contentString,
                            maxWidth: 300
                        }),
                        marker = new google.maps.Marker({
                            position: myLatlng,
                            map: map,
                            title: businessName
                        });

                    if (geocoder) {
                        geocoder.geocode({'address': address}, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
                                    map.setCenter(results[0].geometry.location);

                                    var marker = new google.maps.Marker({
                                        position: results[0].geometry.location,
                                        map: map,
                                        title: address
                                    });
                                    google.maps.event.addListener(marker, 'click', function () {
                                        infowindow.open(map, marker);
                                    });

                                } else {
                                    alert("No results found");
                                }
                            } else {
                                alert("Geocode was not successful for the following reason: " + status);
                            }
                        });
                    }

                    return {
                        init: function () {
                            map.set('styles', [{
                                featureType: 'landscape',
                                elementType: 'geometry',
                                stylers: [
                                    {hue: '#ffff00'},
                                    {saturation: 30},
                                    {lightness: 10}
                                ]
                            }
                            ]);

                            google.maps.event.addListener(marker, 'click', function () {
                                infowindow.open(map, marker);
                            });
                        }
                    };
                }());

                bittersMap.init();
            }//
        },

        // Pages with rotators
        'has_rotator': {
            init: function () {

                /**
                 * Initialize Rotators
                 */
                var rotators = $('.rotator-wrap');
                $(rotators).each(function (i) {
                    var owlEl = $(rotators[i]).find('.rotator'),
                        slides = $(rotators[i]).find('.banner'),
                        prevSlide = $(rotators[i]).find('.rotator-prev'),
                        nextSlide = $(rotators[i]).find('.rotator-next');

                    if (slides.length > 1) {
                        $(owlEl).addClass('owl-carousel').owlCarousel({
                            animateOut: 'fadeOut',
                            items: 1,
                            loop: true
                        });
                        if (prevSlide.length) {
                            prevSlide.on('click', function () {
                                owlEl.trigger('prev.owl.carousel');
                            });
                        }
                        if (nextSlide.length) {
                            nextSlide.on('click', function () {
                                owlEl.trigger('next.owl.carousel');
                            });
                        }
                    }
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = RiseBase;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
